import React from "react"
import { useTranslation } from "react-i18next"

import { ColorScheme } from "shared/context/color-scheme/ColorScheme"
import { useColorScheme } from "shared/lib/color-scheme/useColorScheme"
import { Button, ButtonVariant } from "shared/ui/buttons/Button"

import DarkIcon from "assets/color-icons/mail-green-check-dark.svg"
import LightIcon from "assets/color-icons/mail-green-check-light.svg"

import "./styles/_email-verification-page.scss"

export interface EmailVerificationPageViewProps {
  navigate: () => void
  headline: string
  subText: string
}

export const EmailVerificationPageView = React.memo(
  ({ navigate, headline, subText }: EmailVerificationPageViewProps) => {
    const { t } = useTranslation()
    const { activeColorScheme } = useColorScheme()

    return (
      <div id="email-verification-page" className="email-verification-page">
        <img
          className="email-verification-page__icon"
          src={activeColorScheme === ColorScheme.DARK ? DarkIcon : LightIcon}
          alt="E-Mail Icon"
        />
        <h1 className="email-verification-page__headline">{headline}</h1>
        <span className="email-verification-page__subtext h4">{subText}</span>
        <Button
          variant={ButtonVariant.TERTIARY}
          className="btn-link"
          onClick={navigate}
        >
          {t("EmailVerificationPage.BackToHome")}
        </Button>
      </div>
    )
  }
)
